<h3>Sprememba gesla</h3>

<form [formGroup]="resetForm" novalidate (submit)="reset(resetForm)">
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="form-group">
        <label for="password">Geslo</label>
        <input type="password" class="form-control" id="password" formControlName="password">
      </div>

      <div class="form-group">
        <label for="password2">Ponovite geslo</label>
        <input type="password" class="form-control" id="password2" formControlName="password2">
      </div>
    </div>
  </div>
  <hr>
  <div class="d-flex justify-content-between">
    <div>
      <div class="style-msg successmsg" *ngIf="formSuccess">
        <div class="sb-msg">
          <i class="icon-thumbs-up"></i>
          <strong>Bravo!</strong>
          Novo geslo je bilo nastavljeno
        </div>
      </div>
      <div class="style-msg errormsg" *ngIf="formError">
        <div class="sb-msg">
          <i class="icon-thumbs-up"></i>
          <strong>Napaka!</strong>
          {{formError}}
        </div>
      </div>
    </div>
    <button type="submit" class="button button-3d button-primary button-disabled" [disabled]="formProcessing">
      <i class="la la-check" *ngIf="!formProcessing"></i>
      <i class="la la-spinner la-spin" *ngIf="formProcessing"></i>
      Nastavi geslo
    </button>
  </div>
</form>
